import { render } from "./QuickRouting.vue?vue&type=template&id=40637bb4&scoped=true&ts=true"
import script from "./QuickRouting.vue?vue&type=script&lang=ts"
export * from "./QuickRouting.vue?vue&type=script&lang=ts"

import "./QuickRouting.vue?vue&type=style&index=0&id=40637bb4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40637bb4"]])

export default __exports__